import './App.css';
import { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import Turnstile from "react-turnstile";

function BookServicePage() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    postalCode: "",
    serviceType: "",
    lawnArea: "",
    bagClippings: "",
    provideBags: "",
    referral: "",
    referrerName: "",
    message: "",
    photo: null,
    turnstileToken: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const [referrerInputVisible, setReferrerInputVisible] = useState(false);
  const [bagClippingsVisible, setBagClippingsVisible] = useState(false);
  const [bagsInputVisible, setBagsInputVisible] = useState(false);
  const [lawnAreaVisible, setLawnAreaVisible] = useState(false);

  const handleChange = (event) => {
    const { name, value, type, files } = event.target;

    if (name === "serviceType") {
      if (value === "lawn-mowing") {
        setLawnAreaVisible(true);
        setBagClippingsVisible(true);
        setBagsInputVisible(false);
      } else {
        setLawnAreaVisible(false);
        setBagClippingsVisible(false);
        setBagsInputVisible(["weeding/gardening", "leaf-cleanup", "hedge-trimming"].includes(value));
      }
    }

    if (name === "bagClippings") {
      setBagsInputVisible(value === "yes");
    }

    if (name === "referral") {
      setReferrerInputVisible(value === "referral");
      setFormData((prevData) => ({ ...prevData, referral: value }));
    }

    if (name === "referrerName") {
      setFormData((prevData) => ({ ...prevData, referrerName: value }));
    }

    if (type === "file") {
      setFormData((prevData) => ({ ...prevData, [name]: files[0] }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleTurnstile = (token) => {
    setFormData((prevData) => ({ ...prevData, turnstileToken: token }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setResponseMessage("");

    if (!formData.turnstileToken) {
      setResponseMessage("Please complete the CAPTCHA verification.");
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    if (formData.photo) {
      formDataToSend.append("photo", formData.photo);
    }

    try {
      const response = await fetch("https://studentforhire.ca/SendMail.php", {
        method: "POST",
        body: formDataToSend,
      });

      const result = await response.json();
      setResponseMessage(result.message);
      if (result.success !== false) {
        setSubmitted(true);
      }
    } catch (error) {
      setResponseMessage(
        <span style={{ color: 'green' }}>Thank you for your submission! A student will get back to you as soon as possible.</span>
      );
    }
    setLoading(false);
  };

  return (
    <div className="App">
      <header className="App-header">
        <button className="App-logo-button">
          <img src="/new_logo.png" alt="Logo" className="App-logo-image" />
        </button>
        <h1 className="App-logo-text">
          <span className="green-gradient">Student</span>
          <span className="dark-grey-gradient"> For </span>
          <span className="green-gradient">Hire</span>
        </h1>
      </header>
      <main className="App-main App-main-no-bg">
        <div className="form-box">
          {submitted ? (
            <div style={{ backgroundColor: '#d4f8c4', padding: '40px', borderRadius: '30px', textAlign: 'center' }}>
              <p style={{ color: '#1b3a1b', fontSize: '18px', fontWeight: '500' }}>
                Thank you for your submission! A student will get back to you as soon as possible.
              </p>
            </div>
          ) : (
            <form className="form" onSubmit={handleSubmit}>
              <button className="back-button" onClick={() => navigate("/")}>← Back</button>
              <span className="title">Book Service</span>
              <div className="form-container">
                <input type="text" name="fullName" className="input" placeholder="Full Name" required value={formData.fullName} onChange={handleChange} />
                <input type="email" name="email" className="input" placeholder="Email" required value={formData.email} onChange={handleChange} />
                <input type="text" name="postalCode" className="input" placeholder="Postal Code" required value={formData.postalCode} onChange={handleChange} />

                <select name="serviceType" className="input" required value={formData.serviceType} onChange={handleChange}>
                  <option value="" disabled>Select Type of Service</option>
                  <option value="lawn-mowing">Lawn Mowing</option>
                  <option value="weeding/gardening">Weeding/Gardening</option>
                  <option value="leaf-cleanup">Leaf Cleanup</option>
                  <option value="window-cleaning">Window Cleaning</option>
                  <option value="snow-removal">Snow Removal</option>
                  <option value="power-washing">Power Washing</option>
                  <option value="painting">Painting</option>
                  <option value="hedge-trimming">Hedge Trimming</option>
                  <option value="furniture-moving">Furniture Moving</option>
                </select>

                <select name="referral" className="input select-input" required value={formData.referral} onChange={handleChange}>
                  <option value="" disabled>How did you find out about us?</option>
                  <option value="facebook">Facebook Ad</option>
                  <option value="nextdoor">Nextdoor</option>
                  <option value="referral">Referral / From a Friend</option>
                  <option value="google">Google</option>
                  <option value="social-media">Social Media</option>
                  <option value="flyer">Flyer in the Mail</option>
                  <option value="other">Other</option>
                </select>

                <textarea name="message" className="input textarea-input" placeholder="Additional Message" rows="4" value={formData.message} onChange={handleChange} />

                <label className="file-upload-label">
                  Upload a Photo (Optional):
                  <input type="file" name="photo" className="input file-input" accept="image/*" onChange={handleChange} />
                </label>

                <Turnstile className="captcha" sitekey="0x4AAAAAABBP2jBbw7gCcGUI" onVerify={handleTurnstile} />
              </div>
              <button className="App-button submit" disabled={loading}>{loading ? "Submitting..." : "Submit"}</button>
              {responseMessage && <p className="response-message">{responseMessage}</p>}
            </form>
          )}
        </div>
      </main>
    </div>
  );
}


function BookSeasonalPackages() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    postalCode: "",
    serviceType: "",
    lawnArea: "",
    bagClippings: "",
    provideBags: "",
    frequency: "",
    referral: "",
    referrerName: "",
    message: "",
    photo: null,
    turnstileToken: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const navigate = useNavigate();
  const [referrerInputVisible, setReferrerInputVisible] = useState(false);
  const [bagClippingsVisible, setBagClippingsVisible] = useState(false);
  const [bagsInputVisible, setBagsInputVisible] = useState(false);
  const [lawnAreaVisible, setLawnAreaVisible] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [bagClippings, setBagClippings] = useState("");

  const handleChange = (event) => {
    const { name, value, type, files } = event.target;

    setFormData((prevData) => ({ ...prevData, [name]: value }));

    if (name === "serviceType") {
      if (value === "lawn-mowing") {
        setLawnAreaVisible(true);
        setBagClippingsVisible(true);
        setBagsInputVisible(false);
      } else {
        setLawnAreaVisible(false);
        setBagClippingsVisible(false);
        setBagsInputVisible(["weeding/gardening"].includes(value));
      }
    }

    if (name === "bagClippings") {
      setBagsInputVisible(value === "yes");
    }

    if (name === "referral") {
      setReferrerInputVisible(value === "referral");
    }

    if (type === "file") {
      setFormData((prevData) => ({ ...prevData, [name]: files[0] }));
    }
  };

  const handleTurnstile = (token) => {
    setFormData((prevData) => ({ ...prevData, turnstileToken: token }));
  };

  const handleReferralChange = (event) => {
    setReferrerInputVisible(event.target.value === "referral");
  };

  const handleServiceChange = (event) => {
    const service = event.target.value;
    setSelectedService(service);

    if (service === "lawn-mowing") {
      setLawnAreaVisible(true);
      setBagClippingsVisible(true);
      setBagsInputVisible(false);
    } else {
      setLawnAreaVisible(false);
      setBagClippingsVisible(false);
      setBagsInputVisible(service === "weeding/gardening");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setResponseMessage("");

    if (!formData.turnstileToken) {
      setResponseMessage("Please complete the CAPTCHA verification.");
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    if (formData.photo) {
      formDataToSend.append("photo", formData.photo);
    }

    try {
      const response = await fetch("https://studentforhire.ca/SendMailSeasonal.php", {
        method: "POST",
        body: formDataToSend,
      });

      const result = await response.json();
      setResponseMessage(result.message);
    } catch (error) {
      setResponseMessage("Thank you for your submission! A student will get back to you as soon as possible.");
    }
    setLoading(false);
  };

  const handleBagClippingsChange = (event) => {
    const value = event.target.value;
    setBagClippings(value);
    setBagsInputVisible(value === "yes");
  };

  return (
    <div className="App">
      <header className="App-header">
        <button className="App-logo-button">
          <img src="/new_logo.png" alt="Logo" className="App-logo-image" />
        </button>
        <h1 className="App-logo-text">
          <span className="green-gradient">Student</span>
          <span className="dark-grey-gradient"> For </span>
          <span className="green-gradient">Hire</span>
        </h1>
      </header>
      <main className="App-main App-main-no-bg">
        <div class="form-box" onSubmit={handleSubmit}>
          <form class="form">
            <button className="back-button" onClick={() => navigate("/")}>
              ← Back
            </button>

            <span class="title">Book Seasonal Package (April 15 to September 1)</span>
            <div class="form-container">
              <input type="text" name="fullName" className="input" placeholder="Full Name" required value={formData.fullName} onChange={handleChange} />
              <input type="email" name="email" className="input" placeholder="Email" required value={formData.email} onChange={handleChange} />
              <input type="text" name="postalCode" className="input" placeholder="Postal Code" required value={formData.postalCode} onChange={handleChange} />
              
              <select name="serviceType" className="input" required value={formData.serviceType} onChange={handleChange}>
                <option value="" disabled selected>Select Type of Service</option>
                <option value="lawn-mowing">Lawn Mowing</option>
                <option value="weeding/gardening">Weeding/Gardening</option>
              </select>

              {lawnAreaVisible && (
                <select name="lawnArea" className="input" required value={formData.lawnArea} onChange={handleChange}>
                  <option value="" disabled selected>Do you want both front/back lawns cut?</option>
                  <option value="both">Both Front/Back Lawns</option>
                  <option value="one">Only One Lawn (Specify in additional message)</option>
                </select>
              )}

              {bagClippingsVisible && (
                <select name="bagClippings" className="input" required value={formData.bagClippings} onChange={handleChange}>
                  <option value="" disabled selected>Should student bag grass clippings?</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              )}

              {bagsInputVisible && (
                <select name="provideBags" className="input" required value={formData.provideBags} onChange={handleChange}>
                  <option value="" disabled selected>Will you be providing bags?</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              )}

              <select name="frequency" className="input" required value={formData.frequency} onChange={handleChange}>
                <option value="" disabled selected>Weekly or Bi-Weekly Service?</option>
                <option value="weekly">Weekly</option>
                <option value="bi-weekly">Bi-Weekly</option>
              </select>

              <select name="referral" className="input select-input" required value={formData.referral} onChange={handleChange}>
                <option value="" disabled selected>How did you find out about us?</option>
                <option value="facebook">Facebook Ad</option>
                <option value="nextdoor">Nextdoor</option>
                <option value="referral">Referral / From a Friend</option>
                <option value="google">Google</option>
                <option value="social-media">Social Media</option>
                <option value="flyer">Flyer in the Mail</option>
                <option value="other">Other</option>
              </select>

              {referrerInputVisible && (
                <input type="text" name="referrerName" className="input" placeholder="Referrer Name" required value={formData.referrerName} onChange={handleChange} />
              )}

              <textarea name="message" className="input textarea-input" placeholder="Additional Message" rows="4" value={formData.message} onChange={handleChange} />

              <label className="file-upload-label">
                Upload a Photo of Your Lawn/Garden:
                <input type="file" name="photo" className="input file-input" accept="image/*" onChange={handleChange} />
              </label>

              <Turnstile className="captcha"
                sitekey="0x4AAAAAABBP2jBbw7gCcGUI"
                onVerify={handleTurnstile}
              />

            </div>
            <button className="App-button submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
              <div className="arrow-wrapper">
                <div className="arrow"></div>
              </div>
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

function StudentRegistration() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  const handleTurnstile = (token) => {
    setTurnstileToken(token);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setResponseMessage("");

    if (!turnstileToken) {
      setResponseMessage("Please complete the CAPTCHA verification.");
      setLoading(false);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("email", email);
    formDataToSend.append("turnstileToken", turnstileToken);

    try {
      const response = await fetch("https://studentforhire.ca/SendMailRegister.php", {
        method: "POST",
        body: formDataToSend,
      });

      const result = await response.json();
      setResponseMessage(result.message);
    } catch (error) {
      setResponseMessage("Error submitting email.");
    }
    setLoading(false);
  };

  return (
    <div className="App">
      <header className="App-header">
        <button className="App-logo-button">
          <img src="/new_logo.png" alt="Logo" className="App-logo-image" />
        </button>
        <h1 className="App-logo-text">
          <span className="green-gradient">Student</span>
          <span className="dark-grey-gradient"> For </span>
          <span className="green-gradient">Hire</span>
        </h1>
      </header>
      <main className="App-main App-main-no-bg">
        <div class="email-card">
          <span class="card__title">Get Notified</span>
          <p class="card__content">Get Notified When The Student Registration Opens!</p>
          <form className="card__form" onSubmit={handleSubmit}>
            <input 
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={handleChange}
              required
            />

            <Turnstile className="captcha"
              sitekey="0x4AAAAAABBP2jBbw7gCcGUI" 
              onVerify={handleTurnstile}
            />

            <button className="App-button App-button-student header-button submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit"}
              <div className="arrow-wrapper">
                <div className="arrow"></div>
              </div>
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

function HomePage() {
  const [showPopup, setShowPopup] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [selectedService, setSelectedService] = useState("lawn-mowing");
  const [isPaused, setIsPaused] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16938316207";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16938316207');
    `;
    document.head.appendChild(script2);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".animate-on-scroll");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleScroll = () => {
    setIsPaused((prev) => !prev);
  };

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const handleScrollVisibility = () => {
      if (window.scrollY > 200) {
        setShowScrollToTop(true);
      } else {
        setShowScrollToTop(false);
      }
    };

    window.addEventListener('scroll', handleScrollVisibility);
    return () => window.removeEventListener('scroll', handleScrollVisibility);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const sidebar = document.querySelector('.sidebar');
      const burger = document.querySelector('.burger');
      
      if (isSidebarOpen && sidebar && !sidebar.contains(event.target) && !burger.contains(event.target)) {
        setIsSidebarOpen(false);
      }
    };

    if (isSidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <div className="App">
      <header className="App-header">
        <div className="App-header-left">
          <button className="App-logo-button">
            <img src="/new_logo.png" alt="Logo" className="App-logo-image" />
          </button>
          <h1 className="App-logo-text">
            <span className="green-gradient green-gradient-logo">Student</span> 
            <span className="dark-grey-gradient"> For </span> 
            <span className="green-gradient green-gradient-logo">Hire</span>
          </h1>
        </div>

        <nav className="App-header-nav">
          <button className="nav-button" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })} >Pricing</button>
          <button className="nav-button" onClick={() => document.getElementById('seasonal-packages').scrollIntoView({ behavior: 'smooth' })} >Seasonal Packages</button>
          <button className="nav-button" onClick={() => document.getElementById('referrals').scrollIntoView({ behavior: 'smooth' })} >Referrals</button>
        </nav>

        <div className={`header-buttons header-buttons-small`}>
          <div className="App-buttons">
            <button className="App-button App-button-student header-button" onClick={() => navigate('/register')}>
              Register as Student
              <div className="arrow-wrapper">
                <div className="arrow"></div>
              </div>
            </button>
            <button className="App-button header-button" onClick={() => navigate('/book')}>
              Book a Service
              <div className="arrow-wrapper">
                <div className="arrow"></div>
              </div>
            </button>
          </div>
        </div>
        
        <div className="burger" onClick={toggleSidebar}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      <div className={`sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <button className="close-sidebar" onClick={toggleSidebar}>✖</button>
        <nav className="sidebar-nav">
          <button onClick={() => { document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); toggleSidebar(); }}>Pricing</button>
          <button onClick={() => { document.getElementById('seasonal-packages').scrollIntoView({ behavior: 'smooth' }); toggleSidebar(); }}>Seasonal Packages</button>
          <button onClick={() => { document.getElementById('referrals').scrollIntoView({ behavior: 'smooth' }); toggleSidebar(); }}>Referrals</button>
          <button onClick={() => navigate('/register')}>Register as Student </button>
          <button onClick={() => navigate('/book')}>Book a Service</button>
        </nav>
      </div>

    <main id="home" className="App-main">
      <div id="google-tag-manager">
        <p style={{ textAlign: "center", fontWeight: "bold", color: "#555" }}>
        </p>
      </div>

      <div className="App-main-title animate-on-scroll">
        <h1><span className="dark-grey-gradient">Connecting</span> <span className="green-gradient highlight">Students</span></h1>
        <h1><span className="dark-grey-gradient">With Landscaping</span> <span className="green-gradient highlight">For Your Home</span></h1>
      </div>

      <div className="sub-text animate-on-scroll">
        <p>Qaulity Lawn Care By Hardworking Students In Your Neighborhood</p>
      </div>
        
        <div className="App-buttons">
        <button className="App-button animate-on-scroll" onClick={() => navigate('/book')}>
            Book a Service
            <div className="arrow-wrapper">
              <div className="arrow"></div>
            </div>
          </button>
          <button className="App-button App-button-student animate-on-scroll" onClick={() => navigate('/register')}>
            Register as Student
            <div className="arrow-wrapper">
              <div className="arrow"></div>
            </div>
          </button>
        </div>
    </main>

    {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h2>Which type of service would you like to book?</h2>
            <button className="App-button" onClick={() => navigate('/book')}>
              Book a One Time Service
            </button>
            <button className="App-button" onClick={() => navigate('/packages')}>Book a Seasonal Package</button>
            <button className="close-button" onClick={() => setShowPopup(false)}>✖</button>
          </div>
        </div>
      )}

    <section id="services" className="App-services">
        <h2 className="App-services-title animate-on-scroll">Services We Offer</h2>

        <div className="App-services-list">
          <div className="first-4-rows animate-on-scroll">
            {[
              { title: "Lawn Mowing", img: "/lawnmowing.png", price: "Starting at $50 for front and back lawns, $35 for one side." },
              { title: "Weeding", img: "/weeding.png", price: "Only $30/hour" },
              { title: "Gardening", img: "/gardening.png", price: "Only $30/hour" },
              { title: "Leaf Cleanup", img: "/leafcleanup.png", price: "Only $30/hour" },
              { title: "Window Cleaning", img: "/cleaning.png", price: "Only $30/hour" },
            ].map((service, index) => (
              <div className="card" key={index}>
                <div className="card-inner">
                  <div className="card-front">
                    <div className="header">
                      <div className="img-box">
                        <img src={service.img} alt={service.title} />
                      </div>
                      <span className="title">{service.title}</span>
                    </div>
                  </div>
                  <div className="card-back">
                    <p>{service.price}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="last-4-rows animate-on-scroll">
            {[
              { title: "Snow Removal", img: "/snowremoval.png", price: "Only $30/hour" },
              { title: "Power Washing", img: "/powerwashing.png", price: "Only $40/hour" },
              { title: "Painting", img: "/painting.png", price: "Only $30/hour" },
              { title: "Hedge Trimming", img: "/hedgetrimming.png", price: "Only $30/hour" },
              { title: "Furniture Moving", img: "/moving.png", price: "Only $30/hour" },
            ].map((service, index) => (
              <div className="card" key={index}>
                <div className="card-inner">
                  <div className="card-front">
                    <div className="header">
                      <div className="img-box">
                        <img src={service.img} alt={service.title} />
                      </div>
                      <span className="title">{service.title}</span>
                    </div>
                  </div>
                  <div className="card-back">
                    <p>{service.price}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="seasonal-packages" className="seasonal-packages">
        <h2 className="App-services-title animate-on-scroll">Seasonal Packages</h2>

        <div className="radio-input animate-on-scroll">
          <label>
            <input
              type="radio"
              name="service"
              value="lawn-mowing"
              checked={selectedService === "lawn-mowing"}
              onChange={() => setSelectedService("lawn-mowing")}
            />
            <span>Lawn Mowing</span>
          </label>
          <label>
            <input
              type="radio"
              name="service"
              value="weeding-gardening"
              checked={selectedService === "weeding-gardening"}
              onChange={() => setSelectedService("weeding-gardening")}
            />
            <span>Weeding/Gardening</span>
          </label>
          <span className="selection"></span>
        </div>

        <div className="package-options animate-on-scroll">
          {selectedService === "lawn-mowing" ? (
            <>
              <div className="package-card">
                <h3>Weekly</h3>
                <p1>Starting at <span className="price">$24.95/week</span></p1>
                <button className="App-button small-button" onClick={() => navigate('/book')}>Book Today
                  <div className="arrow-wrapper">
                    <div className="arrow"></div>
                  </div>
                </button>
              </div>

              <div className="package-card">
                <h3>Bi-Weekly</h3>
                <p1>Starting at <span className="price">$29.99/week</span></p1>
                <button className="App-button small-button" onClick={() => navigate('/book')}>Book Today
                  <div className="arrow-wrapper">
                    <div className="arrow"></div>
                  </div>
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="package-card">
                <h3>Weekly</h3>
                <p1>Starting at <span className="price">$19.99/week ($19.99/hour)</span></p1>
                <button className="App-button small-button" onClick={() => navigate('/book')}>Book Today
                  <div className="arrow-wrapper">
                    <div className="arrow"></div>
                  </div>
                </button>
              </div>

              <div className="package-card">
                <h3>Bi-Weekly</h3>
                <p1>Starting at <span className="price">$24.99/week ($24.99/hour)</span></p1>
                <button className="App-button small-button" onClick={() => navigate('/book')}>Book Today
                  <div className="arrow-wrapper">
                    <div className="arrow"></div>
                  </div>
                </button>
              </div>
            </>
          )}
        </div>
      </section>

      <section className="ratings">
        <h2 className="ratings-text animate-on-scroll">Jobs Students Have Completed</h2>
        <div className={`scrolling-container ${isPaused ? "paused" : ""}`}>
          <div className="scrolling-content">
            {[...Array(10)].map((_, i) => (
              <div className="scrolling-group" key={i}>
                <img src="/image1.jpg" alt="Job 1" />
                <img src="/image2.jpg" alt="Job 2" />
                <img src="/image3.jpg" alt="Job 3" />
                <img src="/image4.jpg" alt="Job 4" />
                <img src="/image5.jpg" alt="Job 5" />
              </div>
            ))}
          </div>
        </div>

        <div className="pause-button-container">
          <label className="container">
            <input type="checkbox" checked={isPaused} onChange={toggleScroll} />
            <svg
              className="play"
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 384 512"
            >
              <path
                d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
              ></path>
            </svg>
            <svg
              className="pause"
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 320 512"
            >
              <path
                d="M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
              ></path>
            </svg>
          </label>
        </div>

        <p className="App-services-title feedback animate-on-scroll">
          We Value Your Feedback!
        </p>
        <p className="opinion-matters animate-on-scroll">
          Your opinion matters to us. Please take a moment to rate our service.
        </p>
        <div className="rate-buttons">
          <button className="App-button rate-button animate-on-scroll"
            onClick={() => window.open("https://www.facebook.com/profile.php?id=61560992471558&sk=reviews", "_blank")}>
            Rate on Facebook
            <div className="arrow-wrapper">
              <div className="arrow"></div>
            </div>
          </button>

          <button className="App-button rate-button animate-on-scroll"
            onClick={() => window.open("https://www.google.com/maps/place/Student+For+Hire/@43.9817009,-79.3559759,6z/data=!4m6!3m5!1s0x420ecc5600876621:0xdd18b49685de87ac!8m2!3d43.7182412!4d-79.3780581!16s%2Fg%2F11x5h72nmz?entry=ttu&g_ep=EgoyMDI1MDMxMi4wIKXMDSoASAFQAw%3D%3D", "_blank")}>
            Rate on Google
            <div className="arrow-wrapper">
              <div className="arrow"></div>
            </div>
          </button>
        </div>
      </section>

      <section id="referrals" className="referrals animate-on-scroll">
        <p className="App-services-title feedback">
        Refer Someone and Get <span className="discount">15%</span> Off Your Next Purchase!
        </p>

        <button className="App-button rate-button referral-button" onClick={() => navigate('/book')}>
          Use a Referral Today
          <div className="arrow-wrapper">
            <div className="arrow"></div>
          </div>
        </button>
      </section>

      {showScrollToTop && (
        <button class="scroll-to-top" onClick={handleScrollToTop}>
          ↑
        </button>
      )}

      <footer>
        <div class="footer-content">
            <div class="social-icons animate-on-scroll">
                <a href="mailto:info@studentforhire.ca" target="_blank" title="Email"><img src="email.png" alt="Email"></img></a>
                <a href="https://www.facebook.com/profile.php?id=61560992471558" target="_blank" title="Facebook"><img src="facebook.png" alt="Facebook"></img></a>
                <a href="https://www.linkedin.com/company/studentforhire" target="_blank" title="LinkedIn"><img src="linkedin.png" alt="Linkedin"></img></a>
                <a href="https://www.instagram.com/studentforhire/" target="_blank" title="Instagram"><img src="instagram.png" alt="Instagram"></img></a>
                <a href="https://www.tiktok.com/@studentforhire" target="_blank" title="Tiktok"><img src="tiktok.png" alt="Tiktok"></img></a>
                <a href="https://www.youtube.com/channel/UCsYSq-9nRYfGqmBVQSdcFXg" target="_blank" title="Youtube"><img src="youtube.png" alt="Youtube"></img></a>
            </div>
        </div>
      </footer>
    </div>
  );
}

function RefreshPage() {
  const navigate = useNavigate();

  return (
    <div className="App">
      <header className="App-header">
        <button className="App-logo-button" onClick={() => navigate("/")}>
          <img src="/new_logo.png" alt="Logo" className="App-logo-image" />
        </button>
        <h1 className="App-logo-text">
          <span className="green-gradient">Student</span>
          <span className="dark-grey-gradient"> For </span>
          <span className="green-gradient">Hire</span>
        </h1>
      </header>
      <main className="popup-box App-main App-main-no-bg">
          <h2>Oops! You've encountered an error.</h2>
          <p>Please return to the home page.</p>
          <button className="App-button go-home" onClick={() => navigate("/")}>
            Go Home
          </button>
      </main>
    </div>
  );
}

function RedirectOnRefresh() {
  const location = useLocation();
  const validRoutes = ["/book", "/packages", "/register"];

  if (validRoutes.includes(location.pathname)) {
    return <Navigate to="/error" />;
  }

  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book" element={<BookServicePage />} />
        <Route path="/packages" element={<BookSeasonalPackages />} />
        <Route path="/register" element={<StudentRegistration />} />
        <Route path="/error" element={<RefreshPage />} />
        <Route path="*" element={<RedirectOnRefresh />} />
      </Routes>
    </Router>
  );
}

export default App;
